var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFontSize = function SvgFontSize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#909A9F",
    d: "m44 12-6-8-6 8h4v8h-4l6 8 6-8h-4v-8zM18.614 8l-12 32h4.274l3.75-10h12.726l3.75 10h4.274l-12-32zm-2.478 18L21 13.03 25.864 26z"
  })));
};
export { SvgFontSize as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQ0IDEyTDM4IDRMMzIgMTJIMzZWMjBIMzJMMzggMjhMNDQgMjBINDBWMTJINDRaTTE4LjYxNCA4TDYuNjE0MDEgNDBIMTAuODg4TDE0LjYzOCAzMEgyNy4zNjRMMzEuMTE0IDQwSDM1LjM4OEwyMy4zODggOEgxOC42MTRaTTE2LjEzNiAyNkwyMSAxMy4wM0wyNS44NjQgMjZIMTYuMTM2WiIgZmlsbD0iIzkwOUE5RiIvPgo8L3N2Zz4K";